import React from 'react';
import { toMoneyStringWithComma } from '../../../helpers/formatters/money-format';
import { Breakdown, Row, Value, Label, Info, LabelValue } from '../../../components/breakdown';

export const CostsBreakdownComponent = React.memo(({ items, faq, goals: { totalCosts }, className }) => {
  return (
    <Breakdown atid='costs-breakdown' className={className}>
      {items.map(({ value, label, ariaLabel, FAQKey }, index) => (
        <Row key={label} icon={index > 0 ? 'breakdown-plus' : null}>
          <LabelValue>{toMoneyStringWithComma(value)}</LabelValue>
          <Label>{label}</Label>
          <Info data={faq?.[FAQKey]} ariaLabel={ariaLabel} nudge='right' />
        </Row>
      ))}
      <Row icon='breakdown-equals' total>
        <Value>{toMoneyStringWithComma(totalCosts)}</Value>
      </Row>
    </Breakdown>
  );
});
